<div class="field">
    <span class="field-title">Descuento convenido</span>
    <number-input [initialPlaceHolder]="'Ingresar un descuento convenido'" [value]="elementSelected"
    [max]="'100'" [isWithPoint]="true" (valueOut)="setElement($event,0)"></number-input>
    <span class="msg-warning" *ngIf="defaultValue != elementSelected">Recordá validar que el descuento convenido sea el correcto para este cliente.</span>
    <!--<span class="msg-warning" *ngIf="showMessageNT">Recordá que si el negocio proviene de RT el descuento convenido es de 0,8%.</span>-->
</div>